import React, { useEffect } from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { MechanismSection } from './MechanismSection';
import { WhatYouGetSection } from './WhatYouGetSection';
import { WhoIsForSection } from './WhoIsForSection';
import { HowItWorksSection } from './HowItWorksSection';
import { ProofSection } from './ProofSection';
import { FAQSection } from './FAQSection';
import { BonusSection } from './BonusSection';
import { FooterSection } from './FooterSection';
import { initMetaPixel } from '../lib/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-131">
      <HeroSection data-id="element-132" />
      <ProblemSection data-id="element-133" />
      <MechanismSection data-id="element-134" />
      <WhatYouGetSection data-id="element-135" />
      <WhoIsForSection data-id="element-136" />
      <HowItWorksSection data-id="element-137" />
      <ProofSection data-id="element-138" />
      <FAQSection data-id="element-139" />
      <BonusSection data-id="element-140" />
      <FooterSection data-id="element-141" />
    </div>;
}